<template>
  <div class="speaker">
    <img
      v-if="photo"
      class="speaker__image"
      :alt="name"
      :src="photo"
      width="60"
      height="60"
    />
    <c-avatar-plug v-else width="60" height="60" :letter="name[0]"/>
    <div>
      <h5 class="speaker__name">{{ name }}</h5>
      <span class="speaker__title">{{ title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    photo: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    onOpenSpeakerModal: {
      type: Function,
      default: () => {},
    }
  },
};
</script>

<style lang="scss" scoped>
.speaker {
  display: grid;
  grid-template-columns: auto 1fr;
  //align-items: center;
  justify-content: flex-start;
  grid-gap: var(--attendee-gap-sm);
  min-width: 1px;
  overflow: hidden;
  cursor: pointer;

  &__image {
    width: 60px;
    min-width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
  }

  &__name {
    font-size: 16px;
    font-weight: 600;
    color: var(--attendee-text-primary-color);
    margin-bottom: var(--attendee-gap-sm);
    //white-space: nowrap;
    min-width: 1px;
    overflow: hidden;
  }

  &__title {
    font-size: 13px;
    display: block;
    margin-bottom: var(--attendee-gap-sm);
    color: var(--attendee-text-secondary-color);
    min-width: 1px;
    overflow: hidden;
  }
}
</style>
